import React, { useEffect, useState } from 'react';

import SquadSemiBoldText from '../../../../../../../components/Text/SquadSemiBoldText';
import { getFoodifoxDataLazy } from '../../../../../../../lib/axios/FoodifoxDataAPI';
import { ParcelUser } from '../../../../../../../lib/types';
import SquadRegularText from '../../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../../components/Text/PingFangRegularText';
import { getFormatPhoneNumber, getWindowWidth } from '../../../../../../../lib/utils/utils';
import RowBetween from '../../../../../../../components/Layout/RowBetween';
import ConfirmUserModal from '../ConfirmUserModal';

const SearchPhone: React.FC<Props> = ({
  isEnglish,
  searchText,
  cabId,
  selectUserCallback,
}) => {
  const [selectUser, setSelectUser] = useState<{ userId: number; userName: string; phoneNumber: string; roomNo: string; registerAddress: string }>();
  const [search] = getFoodifoxDataLazy<ParcelUser[]>('/fox3PDParcelUser/searchByPhone');
  const [data, setData] = useState<ParcelUser[]>();

  useEffect(() => {
    if (searchText != null && searchText.trim().length > 7) {
      search({
        param: {
          registerCabId: cabId,
          phoneKeyWord: searchText,
        },
        onError() {
          setData([]);
        },
        onCompleted(nameData) {
          setData(nameData);
        },
      });
    }
    else {
      setData(undefined);
    }
  }, [searchText]);

  if (data != null && data.length === 0) {
    return (
      <>
        {
          isEnglish ? (
            <SquadRegularText color={'#F44336'} lineHeight={18} textAlign={'center'} marginTop={10} marginBottom={10}>
              No registered resident found.
            </SquadRegularText>
          ) : (
            <PingFangRegularText color={'#F44336'} lineHeight={18} textAlign={'center'} marginTop={10} marginBottom={10}>
              未找到已注册的收件人
            </PingFangRegularText>
          )
        }
      </>
    );
  }

  const userItem = (userVO: ParcelUser) => {
    const phone = getFormatPhoneNumber(userVO.phoneNumber + '', false, true).substring(3);
    const prefix = phone.substring(0, (searchText || '').length);
    const suffix = phone.substring((searchText || '').length);
    return userVO.userNameList?.map((nameVO, index) => {
      return (
        <div
          key={'name-' + nameVO.userId + '-' + index}
          style={{ marginTop: 13 }}
          onClick={() => {
            setSelectUser({
              userId: nameVO.userId,
              userName: nameVO.userName || '',
              phoneNumber: userVO.phoneNumber + '',
              roomNo: nameVO.roomNo || '',
              registerAddress: nameVO.registerAddress || '',
            });
          }}
        >
          <RowBetween>
            <SquadSemiBoldText fontSize={18} maxWidth={getWindowWidth() * 0.66}>
              {nameVO.userName}
            </SquadSemiBoldText>
          </RowBetween>
          <SquadRegularText color={'#8D969C'} fontSize={16} marginTop={10}>
            +61 <span style={{ color: '#00B595' }}>{prefix}</span>
            {suffix}
          </SquadRegularText>
          <div style={{ height: 1, backgroundColor: '#11202B', opacity: 0.1, marginTop: 9 }} />
        </div>
      );
    });
  };

  return (
    <>
      {
        selectUser && (
          <ConfirmUserModal
            onClose={() => setSelectUser(undefined)}
            isEnglish={isEnglish}
            userName={selectUser.userName}
            phoneNumber={selectUser.phoneNumber}
            roomNo={selectUser.roomNo}
            location={selectUser.registerAddress}
            callback={() => {
              selectUserCallback(selectUser.userId, selectUser.userName, selectUser.phoneNumber);
              setSelectUser(undefined);
            }}
          />
        )
      }
      <div style={{ marginTop: 15 }}>
        {
          (data || []).map((userVO) => {
            return (
              <div key={userVO.userId + '-' + userVO.phoneNumber} style={{ width: getWindowWidth() - 50 }}>
                {userItem(userVO)}
              </div>
            );
          })
        }
      </div>
    </>
  );
};

export interface Props {
  isEnglish: boolean;
  cabId: number;
  searchText?: string;
  selectUserCallback: (userId: number, userName: string, phoneNumber: string) => void;
}

export default SearchPhone;
